<template >
<div v-show="$route.fullPath !== '/'">
    <button
        
        :style="{
            backgroundImage: 'url(images/commons/btnDiaporamaWhite.png)'
         }"
         class="addBorderRadius relative w-10 h-10 ml-2 md:w-10 md:h-10 2xl:w-16 2xl:h-16 bg-center bg-no-repeat bg-contain pointer-events-auto  shadow-2xl rounded-full"

         
         v-if="$route.fullPath !== '/catalogue/page-001'"

         @click="$eventbus.$emit('modal:richmedia:show')"
    ></button>
</div>
</template>

<script>
export default {
    name: "BtnDiaporama",
    data() {
        return {
            hotspot:true,
            
        }
    },
    mounted(){
        tippy(this.$el, {
            theme: 'light',
            content: 'Voir les médias',
        })
    }, 
    
}
</script>

<style lang="scss" scoped>
.addBorderRadius{
border-radius: 99999px;
    border: 2px solid #0D94FF;
}
</style>
